/**
 * When true, the sortable card should not claim “primary card” selection on pointer down,
 * so the first click reaches inline fields (text preview, buttons, etc.).
 */
export function shouldDeferCollectionCardPointerSelection(target: EventTarget | null): boolean {
  const el = target instanceof Element ? target : null;
  if (!el) {
    return false;
  }
  if (el.closest('[data-block-text-editor-root], [data-block-text-preview-root]')) {
    return true;
  }
  if (
    el.closest(
      'button, a[href], input, textarea, select, [role="button"], [contenteditable="true"]',
    )
  ) {
    return true;
  }
  return false;
}
